import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardF: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="d6bb48e9-632d-4525-8423-10aa20ef3156"
  />
);
StudioProductsCatalogCardF.displayName = 'StudioProductsCatalogCardF';

export default StudioProductsCatalogCardF;
